<template>
  <div class="mb-3 py-3">
    <div class="px-3">
      <div class="mb-3">
        <div class="fw-medium">
          {{ title }}
        </div>
        <div class="form-text mt-0" v-if="$slots.description || description">
          <slot v-if="$slots.description" name="description" />
          <template v-else>{{ description }}</template>
        </div>
      </div>
      <div v-if="$slots.default" class="mb-3">
        <slot />
      </div>
    </div>
    <div v-if="properties.length > 0" class="list-group list-group-flush overflow-auto border-top" ref="scroller">
      <SuggestedListingProperty
        v-for="p in propertiesSorted"
        class="list-group-item"
        :key="p.property.id"
        :listing="listing"
        :property="p.property"
        :match-host-to-other-hosts="p.matchHostToOtherHosts"
        :match-host-to-property-owner="p.matchHostToPropertyOwner"
      >
        <template #buttons>
          <IconButton icon="geo-alt" @click="$emit('showLocation', p.property.latlng)" title="Center map on this address" />
          <IconButton icon="binoculars" @click="$emit('openStreetView', p.property.latlng)" title="Open street view at this address"/>
        </template>
      </SuggestedListingProperty>
    </div>
  </div>
</template>

<script>
import {Listing} from "@/models/Listing";
import IconButton from "@/components/common/IconButton.vue";
import SuggestedListingProperty from "@/components/SuggestedListingProperty.vue";

export default {
  components: {SuggestedListingProperty, IconButton},
  emits: ['committed', 'showLocation', 'openStreetView'],
  props: {
    listing: Listing,
    title: String,
    description: String,
    properties: {
      type: Array, // [PropertyDetails]
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      propertiesWithMatchingListingHosts: {}
    };
  },
  watch: {
    listing: {
      immediate: true,
      async handler() {
        this.$refs.scroller?.scrollTo(0, 0);
        await this.reloadHostMatches();
      }
    }
  },
  computed: {
    propertiesWithMatchInfo() {
      const host = (this.listing.listingHost || '').toLowerCase();
      return this.properties
      .map(p => {
        return {
          property: p,
          distance: p.distanceFrom(this.listing.latlng),
          matchHostToPropertyOwner: !!host && p.owners.join(', ').toLowerCase().indexOf(host) >= 0,
          matchHostToOtherHosts: this.propertiesWithMatchingListingHosts[p.id] || false
        };
      });
    },
    propertiesSorted() {
      let properties = [...this.propertiesWithMatchInfo];
      properties.sort((p1, p2) => {
        if (p1.matchHostToPropertyOwner !== p2.matchHostToPropertyOwner) {
          return p1.matchHostToPropertyOwner ? -1 : 1;
        }
        if (p1.matchHostToOtherHosts !== p2.matchHostToOtherHosts) {
          return p1.matchHostToOtherHosts ? -1 : 1;
        }
        return p1.distance - p2.distance;
      });
      return properties;
    }
  },
  methods: {
    async reloadHostMatches() {
      this.loading = true;
      try {
        this.propertiesWithMatchingListingHosts = {};
        const hostMatchedListings = await Listing.searchByHost(this.listing.city, this.listing.listingHost);
        hostMatchedListings.forEach(listing => {
          if (listing.verifiedPropertyId) {
            this.propertiesWithMatchingListingHosts[listing.verifiedPropertyId] = true;
          }
        });
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>
